/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SubscriptionChangePlanPreviewView = {
    /**
     * upgrade | sidegrade | downgrade
     */
    direction: SubscriptionChangePlanPreviewView.direction;
    /**
     * ISO 4217 currency code, lowercase (e.g. eur)
     */
    currency: string;
    /**
     * Amount Stripe will charge immediately, in cents. > 0 only for upgrade; 0 for sidegrade and downgrade. Approximate (see amountDueNowIsApproximate).
     */
    amountDueNow: number;
    /**
     * True when amountDueNow is a local approximation (upgrade case). Stripe will compute the exact proration server-side; the actual charge may differ by a few cents. The UI should label it with a "~" when this is true.
     */
    amountDueNowIsApproximate: boolean;
    /**
     * Current plan recurring price, cents.
     */
    oldRecurringPrice: number;
    /**
     * New plan recurring price, cents.
     */
    newRecurringPrice: number;
    /**
     * Unix timestamp of the end of the current paid period.
     */
    currentPeriodEnd: number;
    /**
     * Unix timestamp of when the new plan becomes effective. For upgrade/sidegrade this equals "now"; for downgrade this equals currentPeriodEnd.
     */
    effectiveAt: number;
};
export namespace SubscriptionChangePlanPreviewView {
    /**
     * upgrade | sidegrade | downgrade
     */
    export enum direction {
        UPGRADE = 'upgrade',
        SIDEGRADE = 'sidegrade',
        DOWNGRADE = 'downgrade',
    }
}

